import { useContext } from 'react';

import { Sort, type SortDirection, type SortKey } from '@procurify/ui'
import { isEmpty } from 'lodash'

import { usePagination } from '@webapp/core/hooks/usePagination'
import { type PaginationID } from '@webapp/core/providers/Pagination/pagination.types'
import { PaginationControlsContext } from '@webapp/core/providers/Pagination/PaginationControlsContext'

const SortDirections = {
  DESC: 'desc',
  ASC: 'asc',
} as const

export interface IPaginationSortProps {
  id?: PaginationID
  sortKeys: SortKey[]
}

export const PaginationSort = ({
  id: idOverride,
  sortKeys,
}: IPaginationSortProps) => {
  const { id } = useContext(PaginationControlsContext)

  const paginationId = idOverride || id

  if (!paginationId) {
    throw new Error(
      'PaginationSort must be used within a PaginationControls context or provide an id prop'
    )
  }

  const {
    params: { orderBy },
    updateParams,
  } = usePagination({ id: paginationId })

  const direction =
    orderBy && !isEmpty(orderBy) && orderBy.includes('-')
      ? SortDirections.DESC
      : SortDirections.ASC

  const onSort = ({
    value,
    nextDirection,
  }: {
    value: SortKey
    nextDirection: SortDirection
  }) => {
    const prefix = nextDirection === SortDirections.DESC ? '-' : ''
    const updatedOrderBy = value ? `${prefix}${value.value}` : ''

    updateParams({
      orderBy: updatedOrderBy,
      page: 1,
    })
  }

  return (
    <Sort
      value={orderBy || ''}
      direction={direction}
      options={sortKeys}
      onChange={onSort}
    />
  )
}
